import React from 'react';
import {
  getInstallmentStatusLabel,
  getStatusLabel,
  INSTALLMENT_STATUS_BADGE_COLORS,
  STATUS_BADGE_COLORS,
  VIRTUAL_BADGE_COLORS,
  VIRTUAL_BADGE_LABEL,
} from '../constants';
import { StatusBadgeWrapper } from './style';

interface StatusBadgeProps {
  status: number | null;
  variant?: 'entry' | 'installment';
  /** Ocorrência projetada de uma recorrência, ainda não materializada. */
  virtual?: boolean;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  variant = 'entry',
  virtual = false,
}) => {
  if (virtual) {
    return (
      <StatusBadgeWrapper
        $bg={VIRTUAL_BADGE_COLORS.bg}
        $color={VIRTUAL_BADGE_COLORS.color}
      >
        {VIRTUAL_BADGE_LABEL}
      </StatusBadgeWrapper>
    );
  }

  if (status === null || status === undefined) {
    return <span>—</span>;
  }

  const colorMap =
    variant === 'installment'
      ? INSTALLMENT_STATUS_BADGE_COLORS
      : STATUS_BADGE_COLORS;
  const colors = colorMap[status] ?? {
    bg: '#F0F0F0',
    color: '#666666',
  };
  const label =
    variant === 'installment'
      ? getInstallmentStatusLabel(status)
      : getStatusLabel(status);

  return (
    <StatusBadgeWrapper $bg={colors.bg} $color={colors.color}>
      {label}
    </StatusBadgeWrapper>
  );
};

export default StatusBadge;
